import { render, staticRenderFns } from "./xxzs_list.vue?vue&type=template&id=752e94c8&scoped=true"
import script from "./xxzs_list.vue?vue&type=script&lang=js"
export * from "./xxzs_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX-JYJ\\WEB\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752e94c8",
  null
  
)

export default component.exports